export const sr_SR = {
    LEFT: 'Лево: прелазак на претходни дан.',
    RIGHT: 'Десно: прелазак на следећи дан.',
    DOWN: 'Доле: идите на следећу линију.',
    UP: 'Горе: иди на претходну реду.',
    PGUP: 'Горе: померање на претходни месец.',
    PGDOWN: 'PgDown: идите на следећи месец.',
    HOME: 'Куће: прелазак на претходну годину.',
    END: 'Крај: пребаци за наредну годину.',
    ESC: 'Эку/данас/цлосе: затвори календар. Упутства',
    TITLE: 'Тастатура '
};
